import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/Authentication'

export const AccountFilter = ({ children }) => {
    const auth = useAuth();
    const allowedRoles = ['accountant', 'admin']

    if (auth.user) {

        if (!(auth.user.roles.some(role => allowedRoles.includes(role)))) {
            return <Navigate to={'/'} />
        }
    }

    return children
}